"use client";

import ArrowLongRightIcon from "@heroicons/react/24/solid/ArrowLongRightIcon";

export default function CardButton(props: {
  banner: string;
  id: number;
  company: string;
  venue: {
    id: number;
    title: string;
  };
  discount: number;
}) {
  // const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <button
        // onClick={() => setIsOpen(true)}
        className="px-2 border rounded-full text-assistant border-assistant hover:bg-assistant/30 duration-100 py-1"
      >
        <ArrowLongRightIcon className="size-4" />
      </button>

      {/* <CompanyModal
        {...props}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      /> */}
    </>
  );
}
